<template>
  <div class="coin-info-copy" style="height:100%">
    <div class="box">
      <div class="main" style="height:100%">
        <div class="select">
          <el-input
            v-model="searchCurrencyMsg"
            class="selectEl"
            placeholder="请输入商品名称"
            @keyup.enter.native="searchCurrency"
          >
            <i slot="suffix" class="el-input__icon el-icon-search" @click="searchCurrency"></i>
          </el-input>
        </div>
        <!-- 选择商品大类 -->
        <div class="goods_choose">
          <div class="goods_choose_border"></div>
          <div class="goods_choose_box">
            <!-- <div class="goods_self_choose" :class="isSelfSelectStyle?'select':''" @click="selfSeelctClick()">自选</div> -->
            <div class="goods_tabs">
              <div v-for="(item,i) in classNames" :key="`goods_tabs_cell-${i}`" :class="selectClass.topId==item.topId?'selected':''" class="goods_tabs_cell" @click="changeSelectClass(item)">{{ item.className }}</div>
            </div>
          </div>
        </div>
        <div class="content" style="height:calc(100vh - 108px);overflow:scroll">
          <el-table
            :data="newmarketDetails"
            style="width:100%;cursor:pointer;background:#262941;"
            :default-sort="{prop: 'date', order: 'descending'}"
            :cell-class-name="txtClass"
            :row-class-name="txtRowClass"
            @row-click="markets"
            @sort-change="sortChangeF"
          >
            <el-table-column
              prop="symbol"
              align="left"
              label="商品"
              width="280"
              sortable="custom"
            >
              <template slot-scope="scope">
                <div style="display:flex;align-items: center;justify-content: flex-start;" :class="scope.row.contractMarkFlag == 0 ? 'notFree' : 'optional'">
                  <!-- <span
                    @click.stop="changeSelfSelect(scope.row.symbolId,scope.row._isSelfSelect)"
                  ><i class="el-icon-star-on" :class="scope.row._isSelfSelect ? 'selfSeelctSymbol' : ''"></i></span> -->
                  {{ scope.row.symbol }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="close" align="right" :label="'最新价'" sortable="custom">
              <template slot-scope="scope">
                <div>{{ Number(scope.row.close).toFixed(scope.row.coinDigitalNum) }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="quotechange"
              align="right"
              label="涨跌幅"
              sortable="custom"
            >
              <template slot-scope="scope">
                <!-- eslint-disable-next-line vue/valid-v-bind -->
                <div>{{ scope.row.quotechange | addSign }}&nbsp;&nbsp;</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocol hqWs hqProtocol*/
import {
  mapGetters
} from 'vuex'
export default {
  name: 'CoinInfo',
  data() {
    return {
      newmarketDetailsList: [],
      newmarketDetails: [],
      oldmarketlists: [],
      // isShow: false,
      // isShowAlerady: false,
      // totalAssets: 0,
      // isHeight: 1,
      word: {
        color: 'white',
        weight: '700',
        'border-bottom': 'none'
      },
      wordA: {
        color: 'white',
        weight: '700',
        'border-bottom': 'none'
      },
      wordB: {
        color: 'white',
        weight: '700',
        'border-bottom': 'none'
      },
      wordC: {
        color: 'white',
        weight: '700',
        'border-bottom': 'none'
      },
      searchCurrencyMsg: '',
      // closeNum: 0,
      isSelfSelectStyle: false, // 自选状态
      selfSelectedGoodsIds: [],
      selectClass: {
        'topId': null,
        'className': null
      },
      selfSelectMarketSymbols: []
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter', 'marketDetails', 'tvReadyFlagsGetter']),
    // 分类
    classNames() {
      const classNames = {}
      for (let i = 0; i < this.marketDetails.length; i++) {
        const element = this.marketDetails[i]
        if (element && element.className && element.topId) {
          classNames[`${element.topId}`] = element.className
        }
      }
      const classData = []
      for (const key in classNames) {
        if (Object.hasOwnProperty.call(classNames, key)) {
          const element = classNames[key]
          classData.push({
            'topId': key,
            'className': element
          })
        }
      }
      return classData
    }
  },
  watch: {
    searchCurrencyMsg() {
      this.searchCurrency()
    },
    marketDetails: {
      handler: function(val, oldVal) {
        const that = this
        if (val && oldVal && val.length && oldVal.length) {
          this.isSame(val, oldVal)
        }

        const showDatam = []

        for (let i = 0; i < val.length; i++) {
          var bfs = val[i]['quotechange']
          val[i]['bfs'] = parseFloat(bfs.substring(0, bfs.length - 1))
          val[i]['priceColor'] = 'transparent'

          showDatam.push(val[i])
        }
        that.newmarketDetailsList = showDatam
        // if (that.tvReadyFlagsGetter) {
        // that.newmarketDetails = showDatam
        that.computedclassMarkets()
        // }
      },
      deep: true,
      immediate: true
    },
    tvReadyFlagsGetter() {
      // this.newmarketDetails = this.newmarketDetailsList
      this.computedclassMarkets()
    },
    selectClass(val) {
      this.computedclassMarkets()
    },
    selfSelectMarketSymbols() {
      this.addSelectTarget()
    },
    isSelfSelectStyle() {
      this.computedclassMarkets()
    }
  },

  mounted() {
    // 获取自选信息
    // this.getSelfSelectGoodsIds()
    this.newmarketDetails = this.marketDetails
    this.findSymbolMarkList()

    this.showMarket()
    // this.isHeight = this.item ? this.item.symbolId : this.marketDetails[0].symbolId
  },
  beforeDestroy() {
    hqProtocol.param_SYMBOLS.symbol = []
    hqWs.send(hqProtocol.param_SYMBOLS)
  },
  methods: {
    sortChangeF(column) {
      this.$nextTick(
        this.newmarketDetails.sort((a, b) => {
          const uni = column.order === 'descending' // 是否为倒序排序
          // 分类权重
          if (a.classId !== b.classId) {
            return a.classId - b.classId
          }
          // 排序类型权重
          if (column.prop === 'close') {
            // 最新价
            return uni ? b.close - a.close : a.close - b.close
          } else if (column.prop === 'quotechange') {
            // 涨跌幅
            return uni ? Number(b.quotechange.split('%')[0]) - Number(a.quotechange.split('%')[0]) : Number(a.quotechange.split('%')[0]) - Number(b.quotechange.split('%')[0])
          } else if (column.prop === 'symbol') {
            // 商品
            return uni ? String(a.symbol).localeCompare(b.symbol) : String(b.symbol).localeCompare(a.symbol)
          }
        })
      )
    },
    // 计算当前大类商品 并标注自选状态
    computedclassMarkets() {
      if (this.selectClass.topId) {
        const mArr = []
        for (let i = 0; i < this.newmarketDetailsList.length; i++) {
          const e = this.newmarketDetailsList[i]
          if (e.topId == this.selectClass.topId) {
            mArr.push(e)
          }
        }
        this.newmarketDetails = mArr.map((item) => {
          item._isSelfSelect = false
          return item
        })
        // this.newmarketDetails = mArr
      } else {
        const deepCopyMArr = this.newmarketDetailsList && this.newmarketDetailsList.length > 0 ? JSON.parse(JSON.stringify(this.newmarketDetailsList)) : []
        this.newmarketDetails = deepCopyMArr.map((item) => {
          item._isSelfSelect = false
          return item
        })
        // this.newmarketDetails = JSON.parse(JSON.stringify(this.newmarketDetailsList))
      }
      // addSelectTarget
      this.addSelectTarget()
    },
    // 添加自选状态标注
    addSelectTarget() {
      const arr = JSON.parse(JSON.stringify(this.newmarketDetails))
      this.newmarketDetails = []
      for (let i = 0; i < arr.length; i++) {
        if (this.isSelectedGood(arr[i].symbolId)) {
          arr[i]._isSelfSelect = true
        } else {
          arr[i]._isSelfSelect = false
        }
      }
      this.newmarketDetails = arr
      // 筛选自选商品
      if (this.isSelfSelectStyle) {
        const markets = []
        for (let i = 0; i < this.newmarketDetails.length; i++) {
          if (this.newmarketDetails[i]._isSelfSelect) {
            markets.push(JSON.parse(JSON.stringify(this.newmarketDetails[i])))
          }
        }
        this.newmarketDetails = JSON.parse(JSON.stringify(markets))
      }
    },
    // 分类选择
    changeSelectClass(i) {
      this.isSelfSelectStyle = false
      if (this.selectClass.topId == i.topId) {
        this.selectClass = {
          'topId': null,
          'className': null
        }
      } else this.selectClass = i
    },
    // 改变自选选中状态
    changeSelfSelect(id) {
      const _this = this
      const staus = this.isSelectedGood(id)
      // 新增自选
      if (!staus) {
        protocol.param_addCommodityFirmMark.param.firmId = Number(this.sessionInfoGetter.firmId)
        protocol.param_addCommodityFirmMark.param.commodityId = Number(id)
        http.postFront(protocol.param_addCommodityFirmMark).then(res => {
          if (res && res.data && res.data.code == 0) {
            if (id) _this.selfSelectMarketSymbols.push(id)
          } else {
            this.$message('添加自选失败')
          }
        })
      } else {
        // 删除自选
        protocol.param_deleteCommodityFirmMark.param.firmId = Number(this.sessionInfoGetter.firmId)
        protocol.param_deleteCommodityFirmMark.param.commodityId = Number(id)
        http.postFront(protocol.param_deleteCommodityFirmMark).then(res => {
          if (res && res.data && res.data.code == 0) {
            if (id && _this.selfSelectMarketSymbols) {
              for (let i = 0; i < _this.selfSelectMarketSymbols.length; i++) {
                const element = _this.selfSelectMarketSymbols[i]
                if (element == id) {
                  _this.selfSelectMarketSymbols.splice(i, 1)
                }
              }
            }
          } else {
            this.$message('删除自选失败')
          }
        })
      }
    },
    // 查询自选状态
    findSymbolMarkList() {
      http.postFront(protocol.param_findSymbolMarkList).then(res => {
        if (res && res.data) {
          const { code, message, value } = res.data
          if (Number(code) === 0) {
            this.selfSelectMarketSymbols = value ? value.map((i) => { return i.commodityId }) : []
          } else {
            this.$message(message)
          }
        }
      })
    },
    // 查询是否为自选
    isSelectedGood(symbolId) {
      if (this.selfSelectMarketSymbols && this.selfSelectMarketSymbols.length > 0) {
        let req = false
        for (let i = 0; i < this.selfSelectMarketSymbols.length; i++) {
          const element = this.selfSelectMarketSymbols[i]
          if (element == symbolId) { req = true }
        }
        return req
      } else {
        return false
      }
      // return this.selfSelectMarketSymbols ? Boolean(this.selfSelectMarketSymbols.find((i) => { return i.symbolId == symbolId })) : false
    },
    // // 获取自选信息
    // getSelfSelectGoodsIds() {
    //   const ids = localStorage.getItem('__SELF_SELECTED_GOODS_IDS')
    //   if (ids) {
    //     this.selfSelectedGoodsIds = JSON.parse(ids)
    //   }
    // },
    // // 查询自选状态
    // findIsSelefSelectWithId(id) {
    //   return Boolean(this.selfSelectedGoodsIds.find(i => { return i.symbolId == id }))
    // },
    // // 自选 增
    // selfSelectAddIds(id) {
    //   if (!this.findIsSelefSelectWithId(id)) {
    //     this.selfSelectedGoodsIds.push(id)
    //   }
    // },
    // // 自选 删
    // selfSelectRemoveIds(id) {
    //   if (this.findIsSelefSelectWithId(id)) {
    //     this.selfSelectedGoodsIds.push(id)
    //   }
    // },
    // 修改自选状态
    selfSeelctClick(type) {
      this.isSelfSelectStyle = !this.isSelfSelectStyle
    },
    // 存储数据
    markets(row, event, column) {
      this.$store.commit('item', row)
      this.$emit('confirm')
      // this.isHeight = row.symbolId
    },
    // 涨幅颜色
    txtClass(row, column, rowIndex, columnIndex) {
      if (row.columnIndex == 1) {
        if (row.row.close > row.row.clearPrice) {
          return 'increaseColor'
        } else if (row.row.close < row.row.clearPrice) {
          return 'dropColor'
        } else {
          return ''
        }
      }
      if (row.columnIndex == 2) {
        if (row.row.quotechange == '0.00%') {
          return ''
        }
        return this.setStrClass(
          row.row.quotechange,
          '-',
          'dropColor',
          'increaseColor'
        )
      }
    },
    txtRowClass(row, column, rowIndex, columnIndex) {
      return row && row.row && row.row.symbolId ? row.row.symbolId + 'infoCoin' : ''
    },
    isSame(arr, arr2) {
      const arr1 = this.oldmarketlists
      if (arr.length !== arr1.length) {
        this.setoldmarketlists(arr)
        return false
      }
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i]
        const item1 = arr1[i]
        if (item['close'] == item1['close']) {
          item.priceColor = 'transparent'
        } else if (item['close'] > item1['close']) {
          item.priceColor = 'red' // lvse
          const container = document.getElementsByClassName(
            item.symbolId + 'infoCoin'
          )
          for (let i = 0; i < container.length; i++) {
            const element = container[i]
            element.classList.add('upflash')
            setTimeout(function() {
              element.classList.remove('upflash')
            }, 500)
          }
        } else {
          item.priceColor = 'green' // 红色
          const container = document.getElementsByClassName(
            item.symbolId + 'infoCoin'
          )
          for (let i = 0; i < container.length; i++) {
            const element = container[i]
            element.classList.add('downflash')
            setTimeout(function() {
              element.classList.remove('downflash')
            }, 500)
          }
        }
      }
      this.setoldmarketlists(arr)
    },
    setoldmarketlists(arr) {
      if (arr && arr.length > 0) {
        this.oldmarketlists = JSON.parse(JSON.stringify(arr))
      } else {
        this.oldmarketlists = []
      }
    },
    showMarket: function() {
      this.word.color = 'white'
      // this.word.weight = "blod";
      this.word.backgroundColor = '#357ce1'
      this.wordA.color = '#b0b8db'
      this.wordA.weight = 'blod'
      this.wordA.backgroundColor = 'transparent'
      this.wordB.color = '#b0b8db'
      this.wordB.weight = 'blod'
      this.wordB.backgroundColor = 'transparent'
      this.wordC.color = '#b0b8db'
      this.wordC.weight = 'blod'
      this.wordC.backgroundColor = 'transparent'
      hqWs.send(hqProtocol.param_SYMBOLS)
      hqProtocol.param_searchCurrency.symbol = ['search', '']
      hqWs.send(hqProtocol.param_searchCurrency)
    },
    show: function() {
      this.wordC.color = 'white'
      // this.wordC.weight = "blod";
      this.wordC.backgroundColor = '#357ce1'
      this.word.color = '#b0b8db'
      // this.word.weight = "blod";
      this.word.backgroundColor = 'none'
      this.wordB.color = '#b0b8db'
      // this.wordB.weight = "blod";
      this.wordB.backgroundColor = 'none'
      this.wordA.color = '#b0b8db'
      // this.wordA.weight = "blod";
      this.wordA.backgroundColor = 'none'
      hqProtocol.param_searchCurrency.symbol = ['search', 'other']
      hqWs.send(hqProtocol.param_searchCurrency)
    },
    // 搜索币种
    searchCurrency() {
      const aSearch = ['search', this.searchCurrencyMsg]
      hqProtocol.param_searchCurrency.symbol = aSearch
      hqWs.send(hqProtocol.param_searchCurrency)
    }
  }
}
</script>
<style scoped lang="scss">
  /deep/.el-table .descending .sort-caret.descending{
    border-top-color:#E6E6E6;
  }
.goods_choose{
  margin-top: 10px;
  width:100%;
  height: 36px;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.6);
  line-height: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  .goods_choose_border{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 4px;
    border: 1px solid rgba(220, 223, 230, 0.6);
    z-index: 1;
  }
  .goods_choose_box{
    position: absolute;
    align-items: center;
    justify-content: flex-start;
    border-radius: 4px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    display: flex;
  }
  .goods_self_choose{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height:36px;
    border-radius:2px;
    cursor: pointer;
  }
  .select{
    background: #2483FF;
    color: #ffffff;
  }
  .goods_tabs{
    display: flex;
    flex-direction: row;
    .goods_tabs_cell{
      padding: 11px 16px;
      height: 14px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      cursor: pointer;
    }
    .selected{
      color: #2483FF;
    }
  }
}

.abc {
  background: red;
}
.dropColor div {
  color: #41b37d !important;
}
.increaseColor div {
  color: #d74e5a !important;
}
.money {
  min-height: 263px;
  width: 100%;
  background-color: #262941;
  .one {
    float: left;
    padding: 0 9px;
    width: 280px;
    // min-width: 270px;
    height: 37px;
    line-height: 37px;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
  }

  .two {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    width: 90%;
    margin: 0 auto;
    //white-space: nowrap;
    overflow: hidden;
    div {
      float: left;
      margin-right: 10px;
    }
    span {
      float: right;
    }
  }
}
.box {
  width: 100%;
  height:100%;
  background-color: #262941;
  .main {
    padding: 17px 15px 10px 15px;
    width: calc(100% - 23px);
    margin: 0 auto;
    height: 500px;
    box-sizing: border-box;
    .content {
      background: #262941;
      ul {
        width: 100%;
        height: 39px;
        line-height: 39px;
        margin-bottom: 2px;
        background-color: #262941;
        li {
          float: left;
          width: 33%;
          text-align: center;
        }
      }
      /deep/ .gutter{
        background: #262941;
      }
    }
    .select {
      height: 32px;
      padding-top: 3px;
    }
    .title {
      height: 41px;
      line-height: 41px;
      font-size: 16px;
      margin-bottom: 10px;
      .show {
        // width: 15%;
        text-align: center;
        display: inline-block;
        margin-right: 11%;
        cursor: pointer;
      }
      .optional {
        width: 13%;
        margin-left: 17%;
        display: inline-block;
      }
    }
  }
  .title button {
    line-height: 41px;
    font-size: 16px;
    border: 0;
    background-color: transparent;
  }
  .biaoti {
    height: 36px;
    line-height: 36px;
  }
  .header {
    text-align: center;
    position: relative;
    .top {
      position: absolute;
      top: 20%;
      left: 75%;
    }
    .down {
      position: absolute;
      top: 40%;
      left: 75%;
    }
  }
}
.ggtitle {
  height: 35px;
  font-size: 14px;
  line-height: 35px;
  background: #111217;
  text-indent: 20px;
  font-weight: normal;
  margin-top: 2px;
  /* border-bottom: 1px solid rgba(78, 89, 133, 1); */
}
.login,
.register {
  font-size: 16px;
  color: white;
  line-height: 40px;
  margin-right: 10px;
  margin-left: 10px;
  display: inline-block;
}
.login {
  padding-left: 10px;
}
.showTxt {
  background: rgba(78, 89, 133, 1);
  -webkit-background-clip: text;
  color: transparent; // color: #3868B1;
  font-weight: bold;
  border-bottom: 2px solid rgba(78, 89, 133, 1) !important;
  /* IE8+hack */
  background: transparent\0;
  color: #3868b1;
}
.prohibit-cursor {
  cursor: not-allowed !important;
}
/deep/ .el-table th > .cell {
  white-space: nowrap;
  overflow: hidden;
  font-weight: normal;
  color: #61688a;
  background-color: #262941;
}
@media screen and (max-width: 1600px) {
  .one,
  .two {
    font-size: 12px !important;
  }
  .money .one {
    padding: 0 3%;
  }
}
.coin-info-copy /deep/ .el-table ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.content /deep/ .el-table {
  font-weight: normal;
}
.content /deep/ .has-gutter tr th{
  border-color:#262941;
}
.content /deep/ .el-table::before{
  background: #262941;
}
</style>
<style>
#transCC .coin-info-copy .el-pagination button:disabled,
#transCC .coin-info-copy .el-pagination .btn-prev,
#transCC .coin-info-copy .el-pagination .btn-next,
#transCC .coin-info-copy .el-pager li,
#transCC .coin-info-copy .el-pagination__editor.el-input .el-input__inner,
#transCC .coin-info-copy .el-pagination .el-select .el-input .el-input__inner,
#transCC .coin-info-copy .el-table table tr,
#transCC .coin-info-copy .el-table th,
#transCC .coin-info-copy .el-table {
  background-color: #262941;
}
#transCC
.coin-info-copy
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped.current-row
  td,
#transCC .coin-info-copy .el-table__body tr.current-row > td,
#transCC .coin-info-copy .el-table__body tr.hover-row.current-row > td,
#transCC .coin-info-copy .el-table__body tr.hover-row.el-table__row--striped.current-row > td,
#transCC .coin-info-copy .el-table__body tr.hover-row.el-table__row--striped > td,
#transCC .coin-info-copy .el-table__body tr.hover-row > td {
  background-color: #262941;
}
.selectEl .el-input__inner {
  height: 32px;
  background-color: #262941;
  border: 1px solid #4c5473;
}
.selectEl .el-input__icon.el-icon-search {
  line-height: 32px;
}
.coin-info-copy {
  width: 100%;
}
.coin-info-copy .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #1e243c !important;
}
.coin-info-copy .el-table table tr {
  /* background-color: #31354f !important; */
}
.coin-info-copy .el-table td {
  border-bottom: 1px solid rgba(111, 142, 255, 0.5);
}
.coin-info-copy .el-table .cell {
  font-size: 14px;
  /* text-align: center; */
}
.coin-info-copy .el-table th {
  /* background-color: #1e202b !important; */
  /* background-color: #344072 !important; */
  padding: 0px 0 !important;
}
.coin-info-copy .el-table th .cell {
  padding-left:0;
  /* color: #FFFFFF !important; */
}
.coin-info-copy .el-table .cell {
  /* color: inherit; */
  text-align: left !important;
  padding: 0;
}
.allLinesbox {
  border: 0.5px solid black;
}
.linebox {
  width: 100%;
  height: 40px;
  border: 0.5px solid black;
  color: #ffffff;
  line-height: 40px;
  box-sizing: border-box;
  text-align: center;
  /* background-color: #131625; */
}
.linebox5 {
  height: 40px;
  /* border: 0.5px solid black; */
  line-height: 20px;
  /* background-color: #131625; */
}
.moneyScrollBox {
  height: 247px;
  overflow: scroll;
}
/* .el-table td div {
  text-align: left;
} */
.el-icon-star-on:before {
  font-size: 16px;
}
.notFree .el-icon-star-on:before {
  color: #999999;
}
.optional .el-icon-star-on:before {
  color: #999999;
}
.selfSeelctSymbol{
  color:#2483FF!important;
}
.selfSeelctSymbol::before{
  color:#2483FF !important;
}
</style>
